/**
 * @generated SignedSource<<25265c89a04ea869d79c05df1bfcb79c>>
 * @relayHash d9f3bcb5eebe6cb99ac6fb3fefd24936
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0902fd70363315286e09f91de783d08be8e064f0026bfc36df786c394ec74231

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0902fd70363315286e09f91de783d08be8e064f0026bfc36df786c394ec74231",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
